<template lang="pug">
  div
    a.tab.p-2.px-3(v-b-toggle.sidebar-1="")
      i.fa.fa-bars
    b-sidebar.side-nav(id="sidebar-1", bg-variant="white", width="210px", backdrop)
      b-container.px-5
        .text-center.my-3
          router-link(:to="{name: `Dashboard`}")
            img.icon.my-3(src="@/assets/images/branding/logo_dark.svg")
        b-list-group.text-center(v-if="!account.loggedIn")
          b-list-group-item
            router-link(:to="{name: `login`}") Login
          b-list-group-item
            router-link(:to="{name: `home`}") Exit
        b-list-group(v-else="")
          div(v-for="item in content.items", :key="item.route")
            b-list-group-item.pl-0.py-3(:class="{ 'no-mobile': item.noMobile }")
              router-link(:to="{name: `${item.route}`}", :disabled="item.disabled", :id="`btn${item.route}`") {{ item.label }}
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SettingsMenu',
  props: [
    'content',
  ],
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    ...mapState('account', ['account', 'accountTypes']),
  },
  methods: {
    ...mapActions('account', ['logout']),
  },
};
</script>

<style lang="scss" scoped>
.tab {
  background-color: white;
  border-radius: 0 5px 5px 0;
  position: fixed;
  top: 5px;
  left: -2px;
  z-index: 1000;
}
.side-nav {
    position: relative;
    width: 210px;
    background-color: white;
    transition: width 0.2s ease-out;
    hr {
      border-color: rgba(white, 0.1);
    }
    .list-group-item{
      background-color: transparent;
      border: none;
      color: #808080;
      .router-link-active {
        color: black;
      }
    }
    .icon {
      width: 90%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/structure/SideNav.vue